/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { Stack } from "components";
import useRouting from "hooks/useRouting";
import { useEffect, useState } from "react";
import { useInvitation } from "state/InvitationContext";
import { PageLayout } from "templates";
import RsvpDetails from "./RsvpDetails/RsvpDetails";
import usePreviousRoute from "utils/usePreviousRoute";
import { useGlobal } from "state/GeneralContext";
import { useTranslation } from "react-i18next";
export const invitationDetailTitle = (number) => `Date ${number}`;

const RSVP = () => {
  const { t } = useTranslation();
  const { events } = useGlobal();
  const { invitation } = useInvitation({
    fetchInvitation: true,
    hardFetch: true,
  });
  const { shouldEnterInvitationForm } = useRouting();
  const [invitationDetails, setInvitationDetails] = useState({
    category: "1",
    guest_response: "",
    status: "",
    selected_dates: {},
    suggested_dates: {},
    flight_type: 0,
    event_title: "",
    address: "",
    cover_image: "",
    description: "",
    website: "",
  });
  const goBack = usePreviousRoute();

  useEffect(() => {
    if (invitation?.hasOwnProperty("id")) {
      shouldEnterInvitationForm(invitation);
      const c = invitation.category;
      setInvitationDetails({
        id: invitation.id,
        category: c,
        guest_response: invitation.guest_response,
        flight_type: invitation.flight_type,
        status: invitation.status,
        dates_number: invitation.dates_number,
        companions_number: invitation.companions_number,
        event_title: invitation.event?.title || t("RSVP.invitationCardHeader"),
        location_title: invitation.event?.location_title || "",
        address: invitation.event?.address || "",
        cover_image: invitation.event?.cover_image || "",
        description: invitation.event?.description || "",
        website: invitation.event?.website || "",

        selected_dates:
          +c === 3
            ? invitation.suggested_dates
            : invitation.selected_dates.reduce((sum, curr, i) => {
                const [start, end] = curr.split(",");
                return {
                  ...sum,
                  [invitationDetailTitle(i + 1)]: { start, end },
                };
              }, {}),
        suggested_dates:
          +c === 3
            ? invitation.suggested_dates
            : invitation.suggested_dates.reduce((sum, curr, i) => {
                return { ...sum, [invitationDetailTitle(i + 1)]: curr };
              }, {}),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invitation]);

  const hasMultipleEvents = events && events.length > 1;

  return (
    <PageLayout
      title={
        invitation?.event?.title
          ? t("RSVP.invitationTitleWithEvent", {
              event: invitation.event.title,
            })
          : t("RSVP.invitationTitle")
      }
      note={t("RSVP.invitationMSG")}
      hasGoBack={hasMultipleEvents}
      goBackMethod={goBack}
    >
      <Stack className="w-full mt-5">
        <RsvpDetails
          invitationDetails={invitationDetails}
          setInvitationDetails={setInvitationDetails}
        />
      </Stack>
    </PageLayout>
  );
};

export default RSVP;
